'use client'

import React, { memo } from 'react'

import { OverlayView } from '@react-google-maps/api'

import type { MapMarker } from './types'

interface DefaultHtmlMarkerProps {
  index: number
  marker: MapMarker
  onClick: (marker: MapMarker) => void
}

const DefaultHtmlMarkerComponent: React.FC<DefaultHtmlMarkerProps> = ({
  index,
  marker,
  onClick
}) => {
  const isFirst = index === 0
  const isLast = marker.__isLast === true

  const outerSize = isFirst || isLast ? 28 : 22
  const outerStyle: React.CSSProperties = {
    alignItems: 'center',
    backgroundColor: isFirst
      ? 'rgba(220, 38, 38, 0.3)'
      : isLast
        ? 'rgba(0, 0, 0, 0.3)'
        : '#000000',
    border: isFirst || isLast ? 'none' : '2px solid #FFFFFF',
    borderRadius: '9999px',
    boxSizing: 'border-box',
    cursor: 'pointer',
    display: 'flex',
    height: `${outerSize}px`,
    justifyContent: 'center',
    pointerEvents: 'auto',
    transform: 'translate(-50%, -50%)',
    width: `${outerSize}px`
  }

  const innerStyle: React.CSSProperties | undefined =
    isFirst || isLast
      ? {
          backgroundColor: isFirst ? '#DC2626' : '#000000',
          border: '2px solid #FFFFFF',
          borderRadius: '9999px',
          height: `${Math.max(outerSize - 12, 6)}px`,
          width: `${Math.max(outerSize - 12, 6)}px`
        }
      : undefined

  const handleClick = () => {
    onClick(marker)
  }

  const handleKeyDown: React.KeyboardEventHandler<HTMLDivElement> = (event) => {
    if (event.key === 'Enter' || event.key === ' ') {
      event.preventDefault()
      onClick(marker)
    }
  }

  return (
    <OverlayView mapPaneName="overlayMouseTarget" position={marker.position}>
      <div
        aria-label={marker.title}
        onClick={handleClick}
        onKeyDown={handleKeyDown}
        role="button"
        style={outerStyle}
        tabIndex={0}
        title={marker.title}
      >
        {innerStyle ? <div style={innerStyle} /> : null}
      </div>
    </OverlayView>
  )
}

export const DefaultHtmlMarker = memo(DefaultHtmlMarkerComponent)
DefaultHtmlMarker.displayName = 'DefaultHtmlMarker'
